import { createFileRoute } from '@tanstack/react-router'

import { modemQueries } from 'lib/queries'

import Modem from 'pages/Modem'

export const Route = createFileRoute('/_auth/_global/modems/$imei')({
  component: Modem,
  loader: ({ context: { queryClient }, params: { imei } }) => {
    void queryClient.prefetchQuery(modemQueries.detail(imei))
  },
})
